import { useContext } from "react";
import { ErrorMessage, useFieldFormContext } from "../../common";
import { DonationPageStateContext } from "../state";
import "./optional-data-collection-field.scss";
export const OptionalDataCollectionField = () => {
    const { registerField } = useFieldFormContext();
    const { state } = useContext(DonationPageStateContext);
    const optionalDataCollectionConfig = state.configuration.checkout.optionalDataCollectionFieldConfiguration;

    if (!optionalDataCollectionConfig) {
        return null; // No optional data collection fields configured
    }

    // Value resolved from the original page URL at load time (before react-location rewrote it).
    const queryStringValue = state.auxiliaryDataQueryStringValue;
    const isHidden = optionalDataCollectionConfig.queryStringOnly || queryStringValue !== null;

    const fieldDataName = {
        id: "optionalDataCollection_fieldName",
        name: "optionalDataCollection.fieldName",
    };

    // In hidden mode the value comes from the query string (or is empty if absent).
    // In visible mode the donor types a value; isRequired validation applies.
    const fieldValue = {
        id: "optionalDataCollection_fieldValue",
        name: "optionalDataCollection.fieldValue",
        options: isHidden
            ? { maxLength: 50 }
            : {
                required: { value: optionalDataCollectionConfig.isRequired, message: `Must provide a value for ${optionalDataCollectionConfig.label}` },
                maxLength: 50,
              },
    };

    if (isHidden) {
        // Render hidden inputs only — no visible UI for the donor.
        return (
            <>
                <input type="hidden" value={optionalDataCollectionConfig.auxiliaryDataName} {...registerField(fieldDataName)} />
                <input type="hidden" value={queryStringValue ?? ""} {...registerField(fieldValue)} />
            </>
        );
    }

    return (
        <fieldset className="optional-data-collection">
            <legend>{optionalDataCollectionConfig.sectionHeader}</legend>
            <div className="form-group optional-data-collection-field">
                <label htmlFor="optionalDataCollectionFieldValue">{optionalDataCollectionConfig.label}</label>
                <input type="hidden" value={optionalDataCollectionConfig.auxiliaryDataName} {...registerField(fieldDataName)} />
                <input type="text" {...registerField(fieldValue)} />
                {(optionalDataCollectionConfig.note?.trim() ?? "").length > 0 && <p className="field-note">{optionalDataCollectionConfig.note}</p>}
                <ErrorMessage name={fieldValue.name} />
            </div>
        </fieldset>
    );
};
